import { render, staticRenderFns } from "./myStudentList.vue?vue&type=template&id=3ea3ddd4"
import script from "./myStudentList.vue?vue&type=script&lang=js"
export * from "./myStudentList.vue?vue&type=script&lang=js"
import style0 from "./myStudentList.vue?vue&type=style&index=0&id=3ea3ddd4&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports